import { QuestionMark, TickMark } from "@assets/svg/MyDeliveries";
import CustomText from "@components/CustomText";
import { meta } from "@constants/cplp";
import React from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";

function ItemMarkingBtn({ type = "tick", onPress, count, isActive = false }) {
  const Icon = type === "issue" ? QuestionMark : TickMark;
  const label = type === "issue" ? meta.issue_label : meta.all_found;
  const bgColor = type === "issue" ? "black" : "rgba(0, 171, 89, 1)";
  const color = "white";
  return (
    <TouchableOpacity
      activeOpacity={0.7}
      testID="ItemMarkingBtn"
      onPress={onPress}
      disabled={isActive}
    >
      <View>
        <View style={styles.buttonContainer}>
          <View style={styles.elevation}>
            <View style={{ marginLeft: -4, marginTop: -2 }}>
              <Icon
                style={styles.icon}
                bgColor={isActive ? bgColor : ""}
                color={isActive ? color : ""}
              />
            </View>
          </View>
          <CustomText variant="body_text_4" style={styles.captionTextMargin}>
            {label}
          </CustomText>
        </View>
        {!isActive && count ? (
          <View style={styles.defectiveCount}>
            <CustomText variant="caption_1" style={styles.whiteText}>
              {count}
            </CustomText>
          </View>
        ) : null}
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  defectiveCount: {
    backgroundColor: "rgba(255, 46, 0, 1)",
    position: "absolute",
    borderRadius: 100,
    paddingHorizontal: 7,
    alignContent: "center",
    paddingVertical: 2,
    top: -8,
    left: 35,
    elevation: 4,
  },
  whiteText: {
    color: "white",
    lineHeight: 17,
  },
  captionTextMargin: {
    color: "rgba(0, 0, 0, 0.56)",
    marginTop: 8,
  },
  elevation: {
    backgroundColor: "white",
    borderRadius: 16,
    width: 32,
    height: 32,
    elevation: 4,
  },
  buttonContainer: {
    alignItems: "center",
  },
});

export default ItemMarkingBtn;
